import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { BusinessUnit } from '../../../models/business-unit/business-unit.model';
import { BusinessUnitSerializer } from '../../../models/business-unit/business-unit-serializer.class';
import { QueryOptions } from '../../../models/query-options/query-options.class';

/**
 * Service to communicate with API Client Users
 */

@Injectable()
export class BusinessUnitsService extends BaseApiService<BusinessUnit> {
  private _cachedList$: Observable<BusinessUnit[]> | undefined;

  public constructor(httpClient: HttpClient) {
    super(
        httpClient,
        null,
        "businessunits",
        new BusinessUnitSerializer(),
        new CustomErrorHandlerService());
  }

  /**
   * Returns all business units. Result is cached for the session lifetime so
   * navigating between pages does not trigger repeated network requests.
   * BUs rarely change; the cache is shared across all subscribers.
   */
  public override list(queryOptions?: QueryOptions): Observable<BusinessUnit[]> {
    if (!this._cachedList$) {
      this._cachedList$ = super.list(queryOptions).pipe(shareReplay(1));
    }
    return this._cachedList$;
  }

  /**
   * Invalidates the cached BU list so the next list() performs a fresh
   * network request. Call after create/update/delete mutations.
   */
  public clearCache(): void {
    this._cachedList$ = undefined;
  }
}
